var React = require('react');

function BedroomInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"2","d":"M5,29V12c0-1.1-0.9-2-2-2s-2,0.9-2,2v29h4v-5h40v5h4V29H5z","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M14.1 21.725c3.6 1.7 4.9 6.4 4.9 6.4s-4.5 1.9-8.1.1c-3.6-1.7-4.9-6.3-4.9-6.3S10.5 20.025 14.1 21.725zM49 29H21v-6h24c2.2 0 4 1.8 4 4V29z","key":1})]);
}

BedroomInline.defaultProps = {"fill":"currentColor","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = BedroomInline;

BedroomInline.default = BedroomInline;
